// Module
var code = "<template><div class=\"partial-activity-assignment\" if.bind=\"!isUpcomingAssignment\"><p>${'auto-credit-player-activity-message' & t}</p></div></template>";
// Exports
module.exports = code;